import React, { useEffect, useState } from 'react';
import InfoDialog from '../../../../../components/shared/InfoDialog';
import { Stack } from '@mui/material';
import CusInput from '../../../../../components/material-ui/CusInput';
import CollectionCasino from '../collections/CollectionCasino';
import CusButton from '../../../../../components/material-ui/CusButton';
import useToast from '../../../../../hooks/useToast';
import CurrencySelect, { ENUM_CURRENCY } from '../../../../../components/shared/CurrencySelect';
import LoaderContainer from '../../../../../components/material-ui/loader_container/LoaderContainer';
import ShowContainer from '../../../../../components/material-ui/ShowContainer';
import CusSwitch from '../../../../../components/material-ui/CusSwitch';

export default function AddNewCollection({
  casinos,
  openNewCollection,
  setOpenNewCollection,
  addCollection,
  editCollection,
  editInfo,
  getCollectionInfo,
  setEditInfo
}) {
  const { errorToast } = useToast();
  const [currentName, setCurrentName] = useState('');
  const [selectedIds, setSelectedIds] = useState({ type: 'include', ids: new Set() });
  const [currencies, setCurrencies] = useState([ENUM_CURRENCY.all]);
  const [loader, setLoader] = useState(true);
  const [mergeProvider, setMergeProvider] = useState(false);

  const casinoList = editInfo.casinoList || [];
  const casinoListStr = casinoList.join(',');
  const isEdit = !!editInfo;

  useEffect(() => {
    if (!isEdit) {
      setCurrentName('');
      setCurrencies([ENUM_CURRENCY.all]);
      setLoader(!openNewCollection);
      setSelectedIds({ type: 'include', ids: new Set() });
      setMergeProvider(false);

      return;
    }

    setLoader(true);

    getCollectionInfo(editInfo.id)
      .then((data) => {
        const setCasinos = new Set(data.casinoList);

        setCurrentName(data.name);
        setCurrencies(data.currencyList || [ENUM_CURRENCY.all]);
        setMergeProvider(data.mergeProvider);
        setSelectedIds({ type: 'include', ids: setCasinos });
      })
      .catch(console.error)
      .finally(() => setLoader(false));
  }, [isEdit, openNewCollection]);

  const onSaveClick = async () => {
    const resValue = currencies.includes(ENUM_CURRENCY.all) ? [] : currencies;
    if (!currentName) {
      errorToast('Enter the name of the collection');
      return;
    }

    const casinoParam = {
      name: currentName,
      casinoList: Array.from(selectedIds?.ids || []),
      currencyList: resValue,
      mergeProvider
    };

    try {
      if (isEdit) {
        await editCollection(editInfo.id, casinoParam);
      } else {
        await addCollection(casinoParam);
      }

      onClose();
    } catch (e) {
      console.error('er', e);
    }
  };

  const onClose = () => {
    setOpenNewCollection(0);
    setEditInfo(false);
  };

  const title = openNewCollection ? (isEdit ? 'Edit collection' : 'Create a new collection') : '';

  return (
    <InfoDialog
      open={openNewCollection}
      onClose={onClose}
      onSaveClick={onSaveClick}
      saveText={isEdit ? 'Save' : 'Create'}
      title={title}
      maxWidth="xs">
      <LoaderContainer loader={loader} isBox>
        <Stack display={'flex'} direction={'column'} gap={1.5}>
          <CusInput
            label={'Name'}
            value={currentName}
            onChange={(e) => setCurrentName(e.target.value)}
            autoFocus={openNewCollection}
          />

          <CurrencySelect
            label="List of currencies"
            isChooseAll
            allText="Any"
            multi
            value={currencies}
            setValue={setCurrencies}
          />

          <CusSwitch
            label={'Group providers'}
            checked={mergeProvider}
            onChange={() => setMergeProvider((prev) => !prev)}
            tooltipText={
              'If the toggle is enabled, providers with identical names (e.g., the original 3Oaks and its replicas) are grouped together. The list will display a single "3Oaks" provider containing all the games, allowing you to mix original games with replicas.'
            }
          />

          <CollectionCasino
            label={'Use the collection in the casino'}
            casinos={casinos}
            selectedIds={selectedIds}
            setSelectedIds={setSelectedIds}
            disableRowSelectionOnClick={false}
            checkboxSelection={true}
          />
        </Stack>
      </LoaderContainer>
    </InfoDialog>
  );
}
